export default "__VITE_ASSET__C592V5vu__"